<template>
  <page-outline :title="$t('Webheader.country_bic')">
    <template slot="pageContent">
      <f7-list class="mb-2 w-5 ml">
        <f7-list-item>
          <div class="row d-flex">
            <div class="mx-3">
              <b-button class="btn btnFilter"
                :aria-label="$t('common.rfrsh')"
                @click="applyFilter()">
                <i class="fa-light fa-rotate-right"></i>
              </b-button>
            </div>
            <div v-if="false" class="mx-3">
              <b-dropdown :text="$t('administration.countries.bic.change_all_network')" right>
                <b-dropdown-item @click="doAll('all')">{{ $t('common.all') }}</b-dropdown-item>
                <b-dropdown-item @click="doAll('1')">SRTP</b-dropdown-item>
                <b-dropdown-item @click="doAll('2')">GIRO</b-dropdown-item>
                <b-dropdown-item @click="doAll('3')">PSD2</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <div class="px-3 py-2">
                  <b-form-radio-group v-model="selectedAction" stacked>
                    <b-form-radio value="active">Active</b-form-radio>
                    <b-form-radio value="disable">Disable</b-form-radio>
                  </b-form-radio-group>
                </div>
              </b-dropdown>
            </div>
          </div>
        </f7-list-item>
        <!-- Sélection des valeurs de Filtre -->
        <f7-list-item :class="{'filter-item-section':true}">
          <b-row class="min-w-100">
            <!-- Filtre BIC -->
            <b-col sm="6" lg="3" cols="12" class="filter-item mb-3">
              <span class="filter-item-title">BIC</span>
              <span class="filter-item-content">
                <input v-model="BIC"
                  type="text"
                  :class="{'filter-item-input': true, 'filter-item-input-complete': BIC}" placeholder="BIC">
              </span>
            </b-col>
            <!-- Filtre local -->
            <b-col sm="6" lg="3" cols="8" class="filter-item mb-3">
              <span class="filter-item-title">{{ $t('administration.countries.bic.local') }}</span>
              <span class="filter-item-content">
                <select ref="selectDoctype"
                  v-model="local" class="pt-2 cursor fs-14px-important h-auto z-2">
                  <option value="">-</option>
                  <option value="0"> {{ $t('administration.no') }} </option>
                  <option value="1"> {{ $t('administration.yes') }} </option>
                </select>
                <i class="fa-light fa-chevron-down p-1 cursor float-right mt--22px-important z-1" id="status-chevron">
                </i>
              </span>
            </b-col>
            <!-- Filtre local -->
            <b-col sm="6" lg="3" cols="8" class="filter-item mb-3">
              <span class="filter-item-title">{{ $t('administration.countries.network') }}</span>
              <span class="filter-item-content">
                <select ref="selectDoctype"
                  v-model="network" class="pt-2 cursor fs-14px-important h-auto z-2">
                  <option value="">-</option>
                  <option value="0">SRTP</option>
                  <option value="1">HRTP</option>
                  <option value="2">PSD2</option>
                </select>
                <i class="fa-light fa-chevron-down p-1 cursor float-right mt--22px-important z-1" id="status-chevron">
                </i>
              </span>
            </b-col>
            <!-- Bouton Effacer et Appliquer -->
            <div lg="3" cols="12" class="d-flex flex-row-reverse mt-3 pr-0">
              <b-button class="btn" size="sm"
                @click="applyFilter()">
                {{ $t('filter.fltr') }}
              </b-button>
              <b-button class="btn mr-3" size="sm"
                @click="clearFilterFields"
                :disabled="!hasInputFilter">
                {{ $t('filter.clr_fltr_field') }}
              </b-button>
            </div>
          </b-row>
        </f7-list-item>
      </f7-list>
      <spinner v-if="activateSpinner"></spinner>
      <b-table hover v-else-if="CountryBICList.length > 0"
      class="table table-striped mx-75"
      :fields="fields"
      :items="CountryBICList"
      empty-text="Pas de résultat">
        <template #cell(local)="data">
          <span v-if="data.value">{{ pickCountryName(data) }}<i class="fa-light fa-plug px-2 btn btn-icon btn-icon-green"/></span>
          <span v-else><i class="fa-light fa-plug-circle-xmark btn btn-icon btn-icon-red"/></span>
        </template>
        <template #cell(networks)="data">
          {{ data.value.split(',').join(' - ') }}
        </template>
        <template #cell(actions)="data">
          <span v-if="data.item.local" @click="deleteBIC(data.item.idRTPBIC)" class="cursor">
            {{ $t('common.rm_label') }}
            <i class="fa-light fa-trash" />
          </span>
          <span v-else @click="addBIC(data.item.idRTPBIC, data)" class="cursor">
            {{ $t('common.add_label') }}
            <i class="fa-light fa-plus" />
          </span>
        </template>
      </b-table>
      <div v-else class="d-flex justify-content-center">
        <span class="noResult">
          {{ $t('common.no_result') }}
        </span>
      </div>
    </template>
  </page-outline>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import Spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'CountryBICList',
  components: {
    'page-outline': PageOutline,
    'spinner': Spinner
  },
  data () {
    return {
      activateSpinner: false,
      BIC: '',
      CountryBICList: [],
      network: '',
      local: '',
      selectedAction: "active"
    }
  },
  computed: {
    fields () {
      let fields = [
        { key: 'BIC', label: 'BIC', class: 'text-center', sortable: false },
        { key: 'local', label: this.$i18n.t('administration.countries.bic.local'), class: 'text-center', sortable: false },
      ]
      fields.push({ key: 'networks', label: 'Networks', class: 'text-center', sortable: false })
      fields.push({ key: 'actions', label: this.$i18n.t('common.actions'), class: 'text-center ', sortable: false })
      return fields
    },
    hasInputFilter () {
      return this.BIC || this.local || this.network
    }
  },
  created () {
    this.applyFilter()
    let that = this
    this.$bus.$on('selected-bic-country', data => {
      that.createBIC(data.idRTPBIC, data.idCountry)
    })
  },
  methods: {
    random() {
      const norms = ["SRTP", "GIRO", "PSD2"];
      const shuffled = norms.sort(() => Math.random() - 0.5);
      const size = Math.floor(Math.random() * norms.length) + 1;
      return shuffled.slice(0, size).join(" - ");
    },
    addAll (network) {
      // TODO : replace country en brut par country reçu à la connexion
      let idCountry = this.$engine.rights.getCurrentCountry().idCountry;
      let that = this
      that.activateSpinner = false
      this.$engine.administration.country.bic.create({
        idCountry: idCountry,
        BIC: this.BIC,
        network: network
      })
      .then(() => {
        that.okMessageBox(this.$i18n.t('administration.countries.bic.added_mul'))
        that.applyFilter()
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    addBIC (idRTPBIC, data) {
      // TODO : replace country en brut par country reçu à la connexion
      let idCountry = this.$engine.rights.getCurrentCountry().idCountry;
      if (!idCountry) {
        let norms = {
          'SRTP': '1',
          'EBA': '1',
          'HRTP': '2',
          'GIRO': '2',
          'PSD2': '3',
        }
        this.$bus.emit('popup-select-bic-country', {idRTPBIC: idRTPBIC, networks: data.item.networks.split(',').map(elem => norms[elem])})
      } else {
        this.createBIC(idRTPBIC, idCountry)
      }
    },
    applyFilter () {
      let that = this
      this.activateSpinner = true
      this.$engine.administration.country.bic.fetch({
        BIC: this.BIC,
        local: this.local
      })
      .then(resp => {
        that.CountryBICList = resp.data.countryBIC
        that.activateSpinner = false
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    clearFilterFields () {
      this.BIC = ''
      this.network = ''
      this.local = ''
    },
    createBIC (idRTPBIC, idCountry) {
      let that = this
      that.activateSpinner = false
      this.$engine.administration.country.bic.create({
        idCountry: idCountry,
        idRTPBIC: idRTPBIC
      })
      .then(() => {
        that.okMessageBox(that.$i18n.t('administration.countries.bic.added'))
        that.applyFilter()
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    deleteAll (network) {
      // TODO : replace country en brut par country reçu à la connexion
      let idCountry = this.$engine.rights.getCurrentCountry().idCountry;
      let that = this
      that.activateSpinner = false
      this.$engine.administration.country.bic.delete({
        idCountry: idCountry,
        BIC: this.BIC,
        network: network
      })
      .then(() => {
        that.okMessageBox(that.$i18n.t('administration.countries.bic.deleted_mul'))
        that.applyFilter()
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    deleteBIC (idRTPBIC) {
      let that = this
      let idCountry = this.$engine.rights.getCurrentCountry().idCountry;
      that.activateSpinner = true
      this.$engine.administration.country.bic.delete({
        idCountry: idCountry,
        idRTPBIC: idRTPBIC
      })
      .then(() => {
        that.okMessageBox(that.$i18n.t('administration.countries.bic.deleted'))
        that.applyFilter()
      })
      .catch(err => {
        that.activateSpinner = false
        errorMessageAlert(err, that)
      })
    },
    doAll (network) {
      if (this.selectedAction === 'active') {
        this.addAll(network)
      } else {
        this.deleteAll(network)
      }
    },
    okMessageBox (message) {
      this.$f7.modal({
        title: message,
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    pickCountryName (data) {
      let getCountries = this.$engine.rights.getCountries()
      if (getCountries[data.item.idCountry]) {
        return getCountries[data.item.idCountry].name
      }
      return data.item.country
    },
    seeCountryDetails (items) {
      let that = this
      this.$engine.administration.country.countryDetails = items[0]
      loadPage(that, {url: '/country/form/' + items[0].idCountry})
    }
  }
}

</script>

<style>
</style>
